import styled from 'styled-components';

import breakpoints from '../../../breakpoints';

export default styled.div`
  transition: transform 500ms cubic-bezier(0.4, 0, 0.2, 1);
  transform: ${({ visible }) => (visible ? 'none' : 'translate3d(0, -500px, 0)')};
  margin-top: 100px;
  z-index: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  height: 500px;
  @media (max-height: 980px) {
    height: 400px;
    margin-top: 10px;
  }
  @media (max-width: ${breakpoints.xs}) {
    margin-top: 10px;
    margin-left: 12vw;
    height: 220px;
  }
  @media (orientation: portrait) and (max-height: ${breakpoints.mobileKeyboardHeight}) {
    opacity: 0;
  }
`;
